"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M21.5971 7.0313c.1465.6093.293 1.5572.3663 2.776L22 11.5l-.0366 1.6927c-.0733 1.2865-.2198 2.2005-.3663 2.8099-.1465.4063-.3663.7448-.6594 1.0156-.3296.3047-.6959.5078-1.1355.6094-.6593.1693-2.1245.2708-4.4689.3385L12 18l-3.3333-.0339c-2.3444-.0677-3.8462-.1692-4.4689-.3385-.4396-.1016-.8425-.3047-1.1355-.6094-.3297-.2708-.5495-.6093-.6594-1.0156-.1831-.6094-.293-1.5234-.3663-2.8099L2 11.5c0-.474 0-1.0495.0366-1.6927.0733-1.2188.1832-2.1667.3663-2.776.11-.4063.3297-.7448.6594-1.0495.293-.2709.696-.474 1.1355-.6094.6227-.1354 2.1245-.2708 4.4689-.3385L12 5l3.3333.0339c2.3444.0677 3.8096.203 4.4689.3385.4396.1354.8059.3385 1.1355.6094.2931.3047.5129.6432.6594 1.0495zM9.9487 14.276l5.2381-2.776-5.238-2.7422v5.5182z"
  })];
};

exports.default = _default;